import React, { useEffect, useRef, useState } from "react";
import Snackbar from "../../../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";
import moment from "moment";
import { studentInternCreate, studentProfileDetail, myInternshipDetail, update_my_internship } from "../../../user.api";
import { useLocation, useHistory } from "react-router-dom";
import {
  builtup,
  euip,
  jointVenture,
  landon,
  ownland,
} from "./components/areadata";
import Qualifications from "./components/qualifications";
import BasicDetails from "./components/basicDetails";
import View from "./components/viewDetails";
import "./style.css";
import Loader from "../../../../../components/loader/loader";
let eighteenYearsAgo = new Date();
eighteenYearsAgo = eighteenYearsAgo.setFullYear(
  eighteenYearsAgo.getFullYear() - 18
);
let convertedDate = new Date(eighteenYearsAgo);
export default function NewCompanyRequest(props) {
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const updateId = searchParams.get("id");

  const [activeStep, setActiveStep] = useState(0);
  const [initialPage, setInitialPage] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [defaultkey, setdefaultkey] = useState("");

  // Check if user is logged in (Candidate/Student/Company) and get their phone number
  const getCompanyUserPhone = () => {
    const token =
      sessionStorage.getItem("token") ||
      props?.state?.payload ||
      localStorage.getItem("token");

    if (token) {
      try {
        const decoded = jwtDecode(token);
        const user = decoded.user || decoded;
        const userType = user?.user_type;

        // Support for Candidates (20), Students (27), Companies (4), and Admins (21)
        if (userType === 20 || userType === 27 || userType === 4 || userType === 21) {
          return (
            user?.mobile_number ||
            user?.phone_no ||
            user?.phone ||
            props.phone ||
            props.mobile_number ||
            ""
          );
        }
      } catch (error) {
        console.error("Error decoding token in regform:", error);
      }
    }

    // Fallback to props (e.g., from OTP flow for non-logged-in registration)
    return props.phone || props.mobile_number || "";
  };

  const [basicData, setBasicData] = useState({
    date_of_birth: "",
    gender: "Male",
    phone_no: getCompanyUserPhone(),
  });
  const [areaData, setAreaData] = useState({});
  const [domainData, setDomain] = useState([]);
  const [addCount, setCount] = useState(1);
  const myRef = useRef(null);
  const [data, setData] = useState({});
  const [languageData, setLanguageData] = useState([
    { language: "Malayalam", checked: false },
    { language: "English", checked: false },
    { language: "Hindi", checked: false },
  ]);
  const [openView, setOpenView] = useState(false);
  const [existingId, setExistingId] = useState(null);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  useEffect(() => {
    const token =
      sessionStorage.getItem("token") ||
      props?.state?.payload ||
      localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const user = decoded.user || decoded;
        const userType = user?.user_type;

        if (updateId) {
          setIsActive(true);
          myInternshipDetail(updateId)
            .then((res) => {
              if (res?.success && res.data) {
                const application = res.data;
                setBasicData((prev) => ({
                  ...prev,
                  ...application,
                  institution_name: application.institution_name || application.institution?.[0]?.institution_name || application.institution?.institution_name || "",
                  date_of_birth: application.date_of_birth
                    ? moment(application.date_of_birth).format("DD-MM-YYYY")
                    : "",
                  file_name: application.file_upload_photo?.split("/").pop(),
                  resume_name: application.resume?.split("/").pop(),
                  rec_letter_name: application.rec_letter?.split("/").pop() || application.rec_letter_name,
                  qualifications: application.intern_qualification
                    ? application.intern_qualification.map((q) => ({
                      ...q,
                      file_name: q.certificate_photo?.split("/").pop(),
                      marks: q.marks || [],
                    }))
                    : [],
                }));

                if (application.intern_languages) {
                  setLanguageData((prev) =>
                    prev.map((l) => ({
                      ...l,
                      checked: application.intern_languages.some(
                        (pl) => pl.language === l.language
                      ),
                    }))
                  );
                }
              }
              setIsActive(false);
            })
            .catch((err) => {
              console.error("Error fetching application for update:", err);
              setIsActive(false);
            });
        } else if (userType == 27 || userType == 20) {
          setIsActive(true);
          studentProfileDetail()
            .then((res) => {
              if (res?.success && res?.data) {
                const profile = res.data;
                setBasicData((prev) => ({
                  ...prev,
                  ...profile,
                  institution_name: profile.institution_name || profile.institution?.[0]?.institution_name || profile.institution?.institution_name || "",
                  date_of_birth: profile.date_of_birth
                    ? moment(profile.date_of_birth).format("DD-MM-YYYY")
                    : prev.date_of_birth,
                  file_name: profile.file_upload_photo?.split("/").pop(),
                  resume_name: profile.resume?.split("/").pop(),
                  rec_letter_name: profile.rec_letter?.split("/").pop() || profile.rec_letter_name,
                  qualifications: profile.intern_qualification
                    ? profile.intern_qualification.map((q) => ({
                      ...q,
                      // Ensure all expected fields are present for the multi-step form
                      file_name: q.certificate_photo?.split("/").pop(),
                      marks: q.marks || [],
                    }))
                    : prev.qualifications,
                }));
                if (profile.intern_languages) {
                  setLanguageData((prev) =>
                    prev.map((l) => ({
                      ...l,
                      checked: profile.intern_languages.some(
                        (pl) => pl.language === l.language
                      ),
                    }))
                  );
                }
              }
              setIsActive(false);
            })
            .catch((err) => {
              console.error("Profile fetch error:", err);
              setIsActive(false);
            });
        }
      } catch (error) {
        console.error("Token error in useeffect:", error);
      }
    }
  }, []);

  const action = (id, data, key) => {
    if (id === 0) {
      myRef.current?.scrollIntoView();
      // BasicDetails completed → go to View
      setActiveStep(1);
      setBasicData({ ...basicData, ...data, domain_types: [] });
    } else if (id === 1) {
      myRef.current?.scrollIntoView();
      // View → GO BACK → return to BasicDetails at internship page (page 2)
      setInitialPage(2);
      setActiveStep(0);
      setdefaultkey(key);
    } else if (id === 2) {
      if (data) {
        // Special case: direct submit from BasicDetails internal preview
        setBasicData({ ...basicData, ...data });
        handleSubmit(data);
      } else {
        handleSubmit();
      }
    }
  };

  const handleSubmit = (optionalData = null) => {
    const dataSource = optionalData || basicData;
    const form = new FormData();

    let langData = [];
    // If we have optionalData, languages might already be processed or we use the source
    if (optionalData?.languages) {
      langData = optionalData.languages.map(l => l.language);
    } else {
      languageData.forEach((item) => {
        if (item.checked) {
          langData.push(item.language);
        }
      });
      if (dataSource.any_other_lang && dataSource.otherLanguages) {
        dataSource.otherLanguages.forEach((item) => {
          if (item.language) langData.push(item.language);
        });
      }
    }

    form.append("address", dataSource.address ?? null);
    form.append(
      "date_of_birth",
      dataSource.date_of_birth
        ? moment(dataSource.date_of_birth, "DD-MM-YYYY").format("YYYY-MM-DD")
        : ""
    );
    form.append("institution_id", dataSource.institution_id ?? null);
    form.append("full_name", dataSource.full_name ?? null);
    form.append("email", dataSource.email ?? null);
    form.append("phone_no", dataSource.phone_no ?? null);
    form.append("gender", dataSource.gender ?? null);

    if (dataSource.photo instanceof File) {
      form.append("photo", dataSource.photo);
    }
    if (dataSource.rec_letter instanceof File) {
      form.append("rec_letter", dataSource.rec_letter);
      form.append("rec_letter_name", dataSource.rec_letter);
    }
    if (dataSource.resume instanceof File) {
      form.append("resume", dataSource.resume);
    }
    langData.forEach((item, i) => {
      form.append(`languages[${i}][language]`, item);
    });

    if (dataSource.qualifications) {
      dataSource.qualifications.forEach((item, i) => {
        form.append(`qualifications[${i}][qualification_type_id]`, item.qualification_type_id);
        form.append(`qualifications[${i}][qualification_id]`, item.qualification_id);
        if (item.stream_id) {
          form.append(`qualifications[${i}][stream_id]`, item.stream_id);
        }
        form.append(`qualifications[${i}][mark_system]`, item.mark_system);
        form.append(`qualifications[${i}][board]`, item.board);
        form.append(`qualifications[${i}][year_passed]`, item.year_passed);

        if (item.marks) {
          item.marks.forEach((m, mIdx) => {
            form.append(`qualifications[${i}][marks][${mIdx}][period_type]`, m.period_type);
            form.append(`qualifications[${i}][marks][${mIdx}][period_number]`, m.period_number);
            if (item.mark_system === "semester_gpa") {
              form.append(`qualifications[${i}][marks][${mIdx}][cgpa]`, m.cgpa);
            } else {
              form.append(`qualifications[${i}][marks][${mIdx}][marks_obtained]`, m.marks_obtained);
              form.append(`qualifications[${i}][marks][${mIdx}][total_marks]`, m.total_marks);
            }
          });
        }

        if (item.certificate_photo instanceof File) {
          form.append(`qualifications[${i}][certificate_photo]`, item.certificate_photo);
        }
      });
    }

    form.append("is_kerala_native", dataSource.is_kerala_native ? 1 : 0);
    form.append("course_completion_status", dataSource.course_completion_status);

    if (dataSource.proposals) {
      dataSource.proposals.forEach((item, i) => {
        form.append(`proposals[${i}][internship_request_id]`, item.internship_request_id);
        form.append(`proposals[${i}][preference_order]`, item.preference_order);
      });
    }

    setIsActive(true);
    const apiCall = updateId ? update_my_internship(updateId, form) : studentInternCreate(form);

    apiCall
      .then((res) => {
        setSnackMessage(res.message || (updateId ? "Update successful!" : "Registration successful!"));
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setIsActive(false);
        const errorData = error.response?.data;
        if (errorData?.existing_application_id) {
          setExistingId(errorData.existing_application_id);
          setSnackMessage(errorData.message || errorData.error);
        } else if (errorData?.error) {
          // If we have detailed validation errors, pick the first one or combine them
          const firstKey = Object.keys(errorData.error)[0];
          const firstError = errorData.error[firstKey][0];

          // Prettify the key (e.g., "qualifications.0.marks.0.cgpa" -> "CGPA")
          let label = firstKey.split('.').pop().replace(/_/g, ' ');
          label = label.charAt(0).toUpperCase() + label.slice(1);

          setSnackMessage(`${label}: ${firstError}`);
        } else {
          setSnackMessage(errorData?.message || "An error occurred during registration");
        }
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };


  const snackbarClose = () => {
    const wasError = isSnackError;
    const currentExistingId = existingId;
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    setExistingId(null);

    if (wasError) {
      if (currentExistingId) {
        history.push(`/internship-applied/${currentExistingId}`);
      }
      return;
    }

    if (!wasError) {
      const token = sessionStorage.getItem("token") || localStorage.getItem("token");
      if (updateId || token) {
        history.push("/internship-applied");
      } else {
        setActiveStep(0);
        setBasicData({
          date_of_birth: "",
          gender: "Male",
        });

        setLanguageData([
          { language: "Malayalam", checked: false },
          { language: "English", checked: false },
          { language: "Hindi", checked: false },
        ]);
        props.logout();
      }
    }
  };

  return (
    <div className="page-bg" ref={myRef}>
      <Loader open={isActive} />
      <div>
        <div className="dash-banner ">
          <div className="tit-txt">
            {updateId ? "Update Internship Request" : "Internship/Training Request"}
          </div>
        </div>
      </div>
      <div className="formbg form-bg">
        <div className="container form-section">
          <div className="items-cont2 container" style={{ padding: "30px !important" }}>
            <div className="form-inner-section">
              {activeStep === 0 && (
                <BasicDetails
                  {...props}
                  key={basicData.id || 'new'}
                  data={basicData}
                  action={action}
                  formData={basicData}
                  languageData={languageData}
                  setLanguageData={setLanguageData}
                  initialPage={initialPage}
                  onDataLoaded={(qData, oData) => {
                    setData(prev => ({ ...prev, qualificationsData: qData, internshipOpportunities: oData }));
                  }}
                />
              )}

              {activeStep === 1 && (
                <View
                  {...props}
                  basicData={basicData}
                  languageData={languageData}
                  action={action}
                  qualificationsData={data.qualificationsData}
                  internshipOpportunities={data.internshipOpportunities}
                />
              )}
            </div>
            <Snackbar
              message={snackMessage}
              error={isSnackError}
              open={snackOpen}
              close={snackbarClose}
            />
            {/* <CommonForm
          action={action}
          buttons={buttons}
          activeStep={activeStep}
          labelData={labelData}
          data={data}
          headlperText={headlperText}
        /> */}
          </div>
        </div>
      </div>
    </div>
  );
}
